import React, { useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import './PhotoSlider.css';
import pp from '../Photoset/pp.svg';
import pp1 from '../Photoset/pp1.svg';
import pp2 from '../Photoset/pp2.svg';

// !!! This component need to install "swiper"
function PhotoSlider() {
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current) {
            // Access Swiper instance and disable touch/swipe interactions
            swiperRef.current.swiper.allowTouchMove = false;
        }
    }, []);

    return (
        <div className="slider-activity">
            <Swiper // Slide's property 
                ref={swiperRef}
                modules={[Navigation, Pagination, A11y, EffectFade]}
                spaceBetween={5}
                slidesPerView={2}
                effect="fade"
                speed={900}
                loop={true}
                navigation={{
                    prevEl: '.swiper-button-prev-photo',
                    nextEl: '.swiper-button-next-photo'
                }}
                pagination={{clickable: true}}
            >
                <SwiperSlide>
                    <div className='content'>
                        <img src={pp} alt="" />
                        <img src={pp2} alt="" />
                        <img src={pp1} alt="" />
                        <img src={pp} alt="" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className='content'>
                        <img className='pp' src={pp1} alt="" />
                        <img className='pp' src={pp} alt="" />
                        <img className='pp' src={pp2} alt="" />
                        <img className='pp' src={pp1} alt="" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className='content'>
                        <img className='pp' src={pp2} alt="" />
                        <img className='pp' src={pp1} alt="" />
                        <img className='pp' src={pp} alt="" />
                        <img className='pp' src={pp} alt="" />
                    </div>
                </SwiperSlide>

            </Swiper>
            <div className='swiper-nav-button-photo'>
                <div className="swiper-button-prev-photo"></div>
                <div className="swiper-button-next-photo"></div>
            </div>  
        </div>

        
    );
}

export default PhotoSlider;